module.exports = __webpack_public_path__ + "static/media/dailySpecial.8e749382.jpg";